// ============================================================
// Max quantity per line item enforcer — limit: 30
// Works with AJAX cart drawer (pub/sub) and direct cart forms
// ============================================================

(function () {
  const MAX_QTY = 30;

  // ── 1. Intercept all fetch/XHR calls to /cart/add.js & /cart/change.js ──
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : input?.url;

    if (url && url.includes('/cart/add.js')) {
      try {
        const body = init?.body;
        let data = typeof body === 'string' ? JSON.parse(body) : body;

        if (data) {
          // Single item: { id, quantity }
          if (data.quantity !== undefined) {
            data.quantity = Math.min(Number(data.quantity), MAX_QTY);
          }
          // Multiple items: { items: [{id, quantity}, ...] }
          if (Array.isArray(data.items)) {
            data.items = data.items.map(item => ({
              ...item,
              quantity: Math.min(Number(item.quantity), MAX_QTY)
            }));
          }
          // init = { ...init, body: JSON.stringify(data) };
          init = {
            ...init,
            body:
              data instanceof URLSearchParams || data instanceof FormData
                ? data
                : JSON.stringify(data),
          };
        }
      } catch (e) {}
    }

    if (url && url.includes('/cart/change.js')) {
      try {
        const body = init?.body;
        let data = typeof body === 'string' ? JSON.parse(body) : body;
        if (data && data.quantity !== undefined) {
          data.quantity = Math.min(Number(data.quantity), MAX_QTY);
          // init = { ...init, body: JSON.stringify(data) };
          init = {
            ...init,
            body:
              data instanceof URLSearchParams || data instanceof FormData
                ? data
                : JSON.stringify(data),
          };
        }
      } catch (e) {}
    }

    return originalFetch.apply(this, [input, init]);
  };

  // ── 2. Clamp quantity inputs on the page (product forms + cart drawer) ──
  function clampInputs() {
    document.querySelectorAll('input[type="number"][name="quantity"]').forEach(input => {
      if (input._qtyLimited) return;
      input._qtyLimited = true;

      input.setAttribute('max', MAX_QTY);

      input.addEventListener('change', function () {
        if (parseInt(this.value, 10) > MAX_QTY) {
          this.value = MAX_QTY;
        }
      });

      input.addEventListener('blur', function () {
        if (parseInt(this.value, 10) > MAX_QTY) {
          this.value = MAX_QTY;
        }
      });
    });
  }

  // Run on load and after any DOM updates (cart drawer re-renders, etc.)
  clampInputs();
  const observer = new MutationObserver(clampInputs);
  observer.observe(document.body, { childList: true, subtree: true });

})();